import { useRef } from "react";
import { useScrollHandler } from "src/hooks/useScrollHandler";
import { MobileListWrapper } from "../LanguageSwitcher.styled";

type MobileMenuListProps = {
  isOpen: boolean;
  isFooter: boolean;
  children: React.ReactNode;
};

function MobileMenuList({ isOpen, isFooter, children }: MobileMenuListProps) {
  const menu = useRef<HTMLDivElement>(null);
  useScrollHandler({ element: menu, bottomPlacement: isFooter, isOpen });

  return isOpen ? (
    <MobileListWrapper ref={menu}>{children}</MobileListWrapper>
  ) : null;
}

export { MobileMenuList };
